import { Spinner } from "@twilio-paste/spinner";
import { Box } from "@twilio-paste/box"
import { Text } from "@twilio-paste/core/text";
import { appStateTypes } from "../../../core/appReducer";
import { FC, useEffect, useState } from "react";
import { Role } from "@ciptex/notified/dist/node/models/Role";
import { MUSIC_ON_HOLD_URL } from "../../../constants";
import { Flex } from "@twilio-paste/core/flex";
import { useNotifiedContext } from "../../../hooks/useNotifiedContext/useNotifiedContext";

interface LoadingScreenProps {
	state: appStateTypes
}

export const LoadingScreen: FC<LoadingScreenProps> = ({ state }: LoadingScreenProps) => {
	const [audio] = useState(new Audio(MUSIC_ON_HOLD_URL));
	const { booking } = useNotifiedContext();

	function playAudio(audios: string[]) {
		audios.forEach((audio) => {
			const audioElement = new Audio(audio);
			audioElement.play();
		});
	}

	useEffect(() => {
		if ( state.participantType === Role.NOTIFIED_VIEWER && state.isLoading ) {
			if (booking?.branding?.mohUrls && booking?.branding?.mohUrls.length > 0) {
				playAudio(booking?.branding?.mohUrls);
			} else {
				audio.play();
				audio.loop = true;
			}
		} else {
			audio.pause();
			audio.currentTime = 0;
		}
	}, [state.isLoading]);

	useEffect(() => {
		return () => {
			audio.pause();
			audio.currentTime = 0;
		};
	}, []);

	return (
		<Box position="relative" display="flex" flexDirection="column" flex={1} minHeight="300px">
			<Flex hAlignContent="center" vAlignContent="center" height="300px">
				<Spinner size="sizeIcon50" decorative={false} title="Loading" />
				<Text as="h4" fontSize="fontSize80" marginLeft="space30">
					{(state.participantType === Role.NOTIFIED_ADMIN || state.participantType === Role.NOTIFIED_HOST) ? "Going Live" : "Joining Live Event"}
				</Text>
			</Flex>
		</Box>
	);
}